import type { EventEmitter } from '@stencil/core';
import { Component, Event, Host, Prop, h } from '@stencil/core';
import type { Components as SyComponents } from '../../../components';

/**
 * @slot - Slot for adding dialog footer.
 */
@Component({
  tag: 'sy-dialog-footer',
  styleUrl: 'scss/index.scss',
  shadow: true,
})
export class DialogFooter {
  /**
   * Defines the label of the dialog-footer submit button
   */
  @Prop({ reflect: true }) submitLabel = 'Save';

  /**
   * Defines the label of the dialog-footer cancel button
   */
  @Prop({ reflect: true }) cancelLabel = 'Cancel';

  /**
   * Sets the position of the footer buttons.
   */
  @Prop({ reflect: true }) buttonsPosition: 'start' | 'end' = 'start';

  /**
   * Event to indicate the click on the dialog-footer submit button.
   */
  @Event({ cancelable: false }) syDialogFooterDidSubmitClick: EventEmitter<void>;

  /**
   * Event to indicate the click on the dialog-footer cancel button.
   */
  @Event({ cancelable: false }) syDialogFooterDidCancelClick: EventEmitter<void>;

  private getButtonAttributes(btnType: string): Partial<SyComponents.SyButton> {
    const attributes: Partial<SyComponents.SyButton> = {
      label: btnType === 'save' ? this.submitLabel : this.cancelLabel,
      content: 'text-only',
      small: false,
      disabled: false,
      color: btnType === 'save' ? 'primary' : undefined,
      variant: btnType === 'save' ? 'filled' : 'clear',
    };

    return attributes;
  }

  render() {
    return (
      <Host>
        <slot>
          <sy-button
            {...this.getButtonAttributes('save')}
            onClick={() => this.syDialogFooterDidSubmitClick.emit()}
          ></sy-button>
          <sy-button
            {...this.getButtonAttributes('cancel')}
            onClick={() => this.syDialogFooterDidCancelClick.emit()}
          ></sy-button>
        </slot>
      </Host>
    );
  }
}
